import { render, staticRenderFns } from "./subAddSkiiScore.vue?vue&type=template&id=27550d64&scoped=true"
import script from "./subAddSkiiScore.vue?vue&type=script&lang=js"
export * from "./subAddSkiiScore.vue?vue&type=script&lang=js"
import style0 from "./subAddSkiiScore.vue?vue&type=style&index=0&id=27550d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27550d64",
  null
  
)

export default component.exports